import {createContext} from "react";

export const LoadingContext = createContext({
    globalLoading: true,
    screenLoading: true,
    setGlobalLoading: (v) => {},
    setScreenLoading: (v) => {},
    isLoading: true
});
